import { combineEpics, ofType } from "redux-observable";
import {
    map,
    catchError,
    switchMap,
    startWith,
    endWith,
    mergeMap,
} from "rxjs/operators";
import { from, of } from "rxjs";
import {
    setProjectAndAffiliations,
    setProjectAndAffiliationsLoading,
    setProjectAndAffiliationsError,
    updateProjectAndAffiliations as updateProjectAndAffiliationsAction,
} from "../../../store/calculation/calculation-input/ProjectHeaderSlice";
import {
    getProjectAndAffiliations,
} from "../../../services/calculations/calculation-input/ProjectTab.service";
import { ProjectStatus } from "../../../utilities/AppConstants";

const fetchProjectAndAffiliationsEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("projectHeader/getProjectAndAffiliations"),
        switchMap((actionData: any) => {
            const id = actionData?.payload;
            return from(getProjectAndAffiliations(id)).pipe(
                mergeMap((response) => {
                    if (response) {
                        let data = response as any;
                        let projectReadOnly = false;
                        if (data?.find((x: any) => x.status === ProjectStatus.acknowldged)) {
                            projectReadOnly = true;
                        } else if (data?.every((x: any) => x.status === ProjectStatus.archived)) {
                            projectReadOnly = true;
                        }
                        return [
                            setProjectAndAffiliations({ data: response, projectReadOnly }),
                            setProjectAndAffiliationsLoading(false)
                        ];
                    } else {
                        return [
                            setProjectAndAffiliations({ data: [], projectReadOnly: false }),
                            setProjectAndAffiliationsLoading(false)
                        ];
                    }
                }),
                catchError((error) => {
                    return of(
                        setProjectAndAffiliationsError(error?.message || "Error fetching project and affiliations"),
                        setProjectAndAffiliationsLoading(false)
                    );
                }),
                startWith(setProjectAndAffiliationsLoading(true))
            );
        })
    );
};

const updateProjectAndAffiliationsEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("projectHeader/updateProjectAndAffiliationsRequest"),
        switchMap((actionData: any) => {
            const data = actionData?.payload;
            return of(updateProjectAndAffiliationsAction(data));
        })
    );
};

export const projectHeaderEpic = combineEpics(
    fetchProjectAndAffiliationsEpic,
    updateProjectAndAffiliationsEpic
);

